import networkReducerFactory from 'utils/networkReducerFactory'

const { requestTrends, trends } = networkReducerFactory('unicorn/trends/', 'TRENDS')

export { requestTrends }
export default trends

export const selectTrends = state => state.trends
